import { render, staticRenderFns } from "./SalaryRates.vue?vue&type=template&id=ccb8143a&scoped=true&"
import script from "./SalaryRates.vue?vue&type=script&lang=js&"
export * from "./SalaryRates.vue?vue&type=script&lang=js&"
import style0 from "./SalaryRates.vue?vue&type=style&index=0&id=ccb8143a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb8143a",
  null
  
)

export default component.exports